import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FetchBalanceResult } from "@wagmi/core";
import { RootState } from "../reducer";

interface IRoles {
  [key: string]: string;
}
interface IPermissions {
  [key: string]: string[];
}

export interface IErrorsValidate {
  [key: string]: string[];
}

export interface AuthState {
  hasBalanceGas: boolean; // false: sai dia chi vi, true: dung dia chi vi
  // value auth
  balanceGas: FetchBalanceResult;
  authLogin: boolean;
  message: any;
  loadingLogin: boolean;
  loadingAuth: boolean;
  roles: IRoles;
  permissions: IPermissions;
  loadingPreLogin: boolean;
  loadingOtpSend: boolean;
  loadingOtpVerify: boolean;
  payloadLogin: {
    email: string;
    password: string;
    userId: string;
  };
  errorsValidate: IErrorsValidate;
  otpTokenEmail: string;
  balanceLimit: number;
  loadingTransaction: boolean;
  isVerifyWallet: boolean;
  isConnectWallet: boolean;
  isRightNetwork: boolean;
  isRightAddress: boolean;
}

export const initialState: AuthState = {
  authLogin: false,
  message: {},
  loadingLogin: false,
  loadingAuth: false,
  roles: {},
  permissions: {},
  loadingOtpSend: false,
  loadingPreLogin: false,
  loadingOtpVerify: false,
  payloadLogin: {
    email: "",
    password: "",
    userId: "",
  },
  errorsValidate: {},
  otpTokenEmail: "",
  hasBalanceGas: false,
  balanceGas: null,
  balanceLimit: 0.1,
  isVerifyWallet: false,
  isConnectWallet: false,
  isRightNetwork: true,
  isRightAddress: false,
  loadingTransaction: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, { payload }: PayloadAction<any>) => {
      state.authLogin = true;
      state.message = payload;
      state.loadingLogin = false;
    },
    loginFailed: (state, { payload }: PayloadAction<any>) => {
      state.authLogin = false;
      state.message = payload;
      state.loadingLogin = false;
    },
    setAuthLogin: (state, { payload }: PayloadAction<boolean>) => {
      state.authLogin = payload;
    },
    setMessage: (state, { payload }: PayloadAction<any>) => {
      state.message = payload;
    },
    loadingLogin: (state) => {
      state.loadingLogin = true;
    },
    loadedAuth: (state, { payload }: PayloadAction<boolean>) => {
      state.loadingAuth = payload;
    },
    setRoles: (
      state,
      { payload }: PayloadAction<{ roles: IRoles; permissions: IPermissions }>
    ) => {
      state.roles = payload.roles;
      state.permissions = payload.permissions;
    },
    preLoginSuccess: (
      state,
      { payload }: PayloadAction<{ email: string; userId: string }>
    ) => {
      state.payloadLogin.email = payload.email;
      state.payloadLogin.userId = payload.userId;
    },
    loadingOtpEmailSend: (state) => {
      state.loadingOtpSend = true;
    },
    otpEmailSendFinished: (state) => {
      state.loadingOtpSend = false;
    },
    loadingOtpEmailVerify: (state) => {
      state.loadingOtpVerify = true;
    },
    otpEmailVerifySuccess: (state, { payload }: PayloadAction<string>) => {
      state.loadingOtpVerify = false;
      state.otpTokenEmail = payload;
    },
    otpEmailVerifyFail: (
      state,
      { payload }: PayloadAction<IErrorsValidate>
    ) => {
      state.otpTokenEmail = null;
      state.errorsValidate = payload;
      state.loadingOtpVerify = false;
    },
    resetState: () => initialState,
    loadBalanceGas: (state, { payload }) => {
      state.hasBalanceGas = !!(
        Number(payload?.formatted) >= state.balanceLimit
      );
      state.balanceGas = payload;
    },

    setIsRightAddress: (state, { payload }: PayloadAction<boolean>) => {
      if (state.isRightAddress !== payload) {
        state.isRightAddress = payload;
      }
    },
    setHasBalanceGas: (state, { payload }: PayloadAction<boolean>) => {
      state.hasBalanceGas =
        state.isRightNetwork && state.isRightAddress && payload;
    },
  },
});

export const sliceActions = authSlice.actions;
export const authReducer = authSlice.reducer;
export const authSelector = (state: RootState) => state.auth;
